import React from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import "../Styles/mapViewStyle.css";
import { Link } from "react-router-dom";

// Create a custom icon for the marker
const customIcon = new L.Icon({
  iconUrl: "https://i.ibb.co/fp1NLC0/Group-4.png", // Replace with your custom icon URL
  iconSize: [50, 50], // Adjust size as needed
  iconAnchor: [25, 50], // Adjust so it points correctly
});

const FitMapToMarkers = ({ listings, fallbackCenter }) => {
  const map = useMap();

  React.useEffect(() => {
    const validListings = listings
      .map((listing) => ({
        ...listing,
        lat: Number(listing?.lat),
        lng: Number(listing?.lng),
      }))
      .filter(
        (listing) =>
          Number.isFinite(listing?.lat) && Number.isFinite(listing?.lng),
      );

    if (validListings.length > 0) {
      const bounds = validListings.map((listing) => [
        listing.lat,
        listing.lng,
      ]);
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 15 });
    } else {
      map.setView(fallbackCenter, 15);
    }
  }, [listings, map, fallbackCenter]);

  return null;
};

const PropertiesMap = ({ listings, className = "" }) => {
  const defaultPosition = [25.079539387772083, 55.12148983415934]; // Default position in Dubai

  return (
    <MapContainer
      center={defaultPosition}
      zoom={15}
      className={className}
      //   style={{ height: "800px", width: "100%", fontSize: "16px" }}
    >
      <FitMapToMarkers listings={listings} fallbackCenter={defaultPosition} />
      <TileLayer url="https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic2hhbWltczM5OSIsImEiOiJjbTJkMTZldWkwY3ZmMnJzYjY3ajB2aTJmIn0.bouAZxiGv_HbAPtsH0nm8A" />
      {listings.map((listing, index) => (
        <Marker
          position={[listing?.lat, listing?.lng]}
          icon={customIcon}
          key={listing?.id}
        >
          <Popup>
            <Link
              className="text-[#74716d] hover:no-underline focus:no-underline focus:text-[#74716d] active:text-[#74716d]"
              to={`/listing/${listing.id}`}
              style={{ textAlign: "center" }}
            >
              <img
                src={listing?.listingImages[0].url}
                alt=""
                className="w-full rounded-md"
              />
              <h3 className="text-[18px] leading-[24px] mt-2 font-medium text-[#74716d]">
                {listing?.name}
              </h3>
              <p className="text-[#74716d]">
                {listing?.personCapacity} guests · {listing?.bedroomsNumber}{" "}
                bedrooms · {listing?.bathroomsNumber} baths
              </p>
            </Link>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default PropertiesMap;
